import _ from "lodash";

export const DATA_LIMIT = 10;

export const DESIGN_BATCH_SIZE = 10;

export const PINTEREST_DASHBOARD_TABS_LIST = [
    {key: 'designs', label: 'Designs'},
    {key: 'pinterestAccounts', label: 'Pinterest Accounts'},
    {key: 'pinterestBoards', label: 'Pinterest Boards'},
    {key: 'pinterestPins', label: 'Pinterest Pins'},
    {key: 'pinterestSyncs', label: 'Pinterest Syncs'},
];


export const DEFAULT_PINTEREST_DASHBOARD_TAB = {key: 'designs', label: 'Designs'};


export const PINTEREST_INFO_IDS_LIST = {
    DESIGNS: "designs",
    PINTEREST_SYNCS: "pinterest-syncs",
    PINTEREST_ACCOUNTS: "pinterest-accounts",
    PINTEREST_BOARDS: "pinterest-boards",
    PINTEREST_PINS: "pinterest-pins",
};


export const PINTEREST_IMAGES_PATH = 'pinterest-images';
export const PINTEREST_SCOPES = 'boards:read,boards:write,pins:read,pins:write,user_accounts:read';
